import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { fetchCountries } from '@modules-deprecated/app/countries/query-api'

import { QueryKeys } from '../../../enums/queryKeys'
import { getCurrentLocale } from '../../../utils'

export const useFetchCountries = () => {
  const locale = getCurrentLocale()
  const { data, ...rest } = useQuery([QueryKeys.Countries, locale], () => fetchCountries(locale))
  const countries = useMemo(() => data?.countries ?? [], [data?.countries])

  return { countries, ...rest }
}
